import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
} from "@/utils/type-vaildator";
import api from "./api";

interface AudioTTSGeneratorParams {
  text: string;
  voice_id: string;
  actor_id: string;
  model_name: string;
  voice_settings: {
    stability: number;
    similarity_boost: number;
    style_exaggeration: number;
    speed: number;
  };
  audio_name: string;
  save_to_db: boolean;
  upload_to_s3: boolean;
}

export interface AudioTTSGeneratorProps {
  text: string;
  voiceTtsId: string;
  actorId: string;
  modelName: string;
  voiceSettings: {
    stability: number;
    similarityBoost: number;
    styleExaggeration: number;
    speed: number;
  };
  audioName: string;
}

// 原始接口
interface AudioTTSGeneratorResponse {
  actor_name: string;
  audio_url: string;
  duration: number;
  id: string;
  message: string;
  model_name: string;
  name: string;
  script: string;
  voice_tts_id: string;
}

// 主数据类
export class AudioTTSGeneratorData {
  @IsString("Actor name must be a string")
  actorName: string;

  @Required("Audio URL cannot be empty")
  @IsString("Audio URL must be a string")
  audioUrl: string;

  @Required("ID cannot be empty")
  @IsString("ID must be a string")
  id: string;

  @Required("Model name cannot be empty")
  @IsString("Model name must be a string")
  modelName: string;

  @IsString("Name must be a string")
  name: string;

  @Required("Voice TTS ID cannot be empty")
  @IsString("Voice TTS ID must be a string")
  voiceTtsId: string;
}

const transformAndValidateAudioTTSGenerator = (
  response: AudioTTSGeneratorResponse
): AudioTTSGeneratorData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, AudioTTSGeneratorData);
  } catch (error) {
    console.error("Audio TTS generator data validation failed:", error.message);
    throw error;
  }
};

const URL = "/audio/tts/generate";

export const audioTTSGenerator = async (
  props: AudioTTSGeneratorProps
): Promise<AudioTTSGeneratorData> => {
  const params: AudioTTSGeneratorParams = {
    text: props.text,
    voice_id: props.voiceTtsId,
    actor_id: props.actorId,
    model_name: props.modelName,
    voice_settings: {
      stability: props.voiceSettings.stability,
      similarity_boost: props.voiceSettings.similarityBoost,
      style_exaggeration: props.voiceSettings.styleExaggeration,
      speed: props.voiceSettings.speed,
    },
    audio_name: props.audioName,
    save_to_db: true,
    upload_to_s3: true,
  };
  const config = {
    timeout: 2 * 60 * 1000,
  };
  const response = await api.post<AudioTTSGeneratorResponse>(URL, params, config);
  const validatedData = transformAndValidateAudioTTSGenerator(response.data);
  return validatedData;
};
